import React, { useContext } from "react";
import Modal from "react-modal";
import { IconButton } from "@mui/material";
import GradientButton from "@tomocredit/common-fe/components/common/GradientButton";
import PartyPopper from "images/iq/party-popper.svg";
import { QRCodeSVG } from "qrcode.react";
import TomoAppIcon from "@tomocredit/common-fe/assets/svg/app-icon.svg";
import AppStore from "@tomocredit/common-fe/assets/svg/app-store-badge_apple.svg";
import PlayStore from "@tomocredit/common-fe/assets/svg/app-store-badge_google.svg";
import {
  BOOST_APP_URL_IOS,
  BOOST_APP_URL_ANDROID,
} from "@tomocredit/common-fe/consts";
import { getOperatingSystem, trackWithCallback } from "@tomocredit/common-fe/utils";
import { BreakpointContext } from "components/common";

export const TomoIQWaitlistModal = ({ isOpen, onClose }) => {
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md");
  const belowXl = belowMd || (Math.min((window.innerHeight || 0) || (window.screen?.height || 0)) < 900); // control for wide screen but low on height; modal will appear funky without this
  const userAgent = getOperatingSystem();
  const isMobileIos = userAgent === "iOS" && belowMd;
  const isMobileAndroid = userAgent === "Android" && belowMd;

  const modalStyle = {
    overlay: {
      zIndex: 20,
      backgroundColor: "rgba(17, 30, 25, 0.72)",
    },
    content: {
      position: "absolute",
      zIndex: 20,
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      border: 0,
      background: "transparent",
      overflow: "hidden",
      outline: "none",
      padding: "0px",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "calc(100% - 64px)",
      maxWidth: belowXl ? "500px" : "604px",
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    },
  };

  const customRedirect = (url) => {
    window.location.href = url;
  };

  // Handle button click to change QR code
  const handleClick = (type) => {
    const storeUrl = type === "iOS" ? BOOST_APP_URL_IOS : BOOST_APP_URL_ANDROID;
    trackWithCallback(`IQ_APP_STORE_CLICK_${type.toUpperCase()}`, { userAgent }, () => customRedirect(storeUrl));
  };

  const getMaxWidth = () => {
    if (belowMd) {
      return 180;
    }
    if (belowXl) {
      return 200;
    }
    return undefined;
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={modalStyle}
    >
      <div className="text-black bg-white rounded-lg overflow-hidden">
        <div
          className="w-full relative"
          style={{ height: belowXl ? 195 : 261, backgroundColor: "#15161A" }}
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: "1rem",
              right: "1rem",
              background: "rgba(225, 225, 225, 1)",
              borderRadius: "20",
              width: "1.5rem",
              height: "1.5rem",
              '&:hover': {
                backgroundColor: '#A9A9A9',
              },
            }}
          >
            <i className="fa-solid fa-xmark text-black"></i>
          </IconButton>
          <img src={PartyPopper} alt="" className="h-full w-auto mx-auto" />
        </div>
        <div style={{ letterSpacing: "-0.25px", padding: belowXl ? 24 : 48 }}>
          <div className={`${belowMd ? "text-lg " : "md:text-2xl "}font-bold`}>
            Welcome 🚀 Download our FREE app!
          </div>
          <div className="mt-6 flex justify-between items-center space-x-10">
            <div className="flex-1 flex flex-col space-y-8 h-full items-center md:items-start">
              {!isMobileAndroid && (
                <button
                  type="button"
                  onClick={() => handleClick("iOS")}
                  className="flex-1 focus:outline-none hover:opacity-80 transition-opacity duration-200 h-full w-full"
                  style={{ maxWidth: getMaxWidth() }}
                >
                  <img src={AppStore} alt="App Store" className="w-full h-auto" />
                </button>
              )}
              {!isMobileIos && (
                <button
                  type="button"
                  onClick={() => handleClick("Android")}
                  className="flex-1 focus:outline-none hover:opacity-80 transition-opacity duration-200 h-full w-full"
                  style={{ maxWidth: getMaxWidth() }}
                >
                  <img src={PlayStore} alt="Play Store" className="w-full h-auto" />
                </button>
              )}
            </div>
            {/* Display QR code */}
            {(!isMobileIos && !isMobileAndroid) && (
              <div className="flex items-center justify-center" style={{ height: "auto", maxWidth: 200 }}>
                <QRCodeSVG
                  id="app-qr-code"
                  value={`${process.env.REACT_APP_DOMAIN}/app`}
                  size={belowXl ? 160 : 200}
                  bgColor="white"
                  fgColor="black"
                  level="H"
                  imageSettings={{
                    src: TomoAppIcon,
                    width: belowXl ? 40 : 50,
                    height: belowXl ? 40 : 50,
                    excavate: true,
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};